export default __webpack_public_path__ + "f8885f5fef55bb9b50fd7896e21e8590.svg";